/**
 * AdminOrcaArchiveRpcClient - AtomRpc integration for admin orca archive endpoints
 *
 * Backs the operator archive surface: `admin.orcaArchive.list` (runs and their
 * objects), `admin.orcaArchive.text` (a rendered line window) and
 * `admin.orcaArchive.downloadUrl` (a pre-signed URL to an object's raw bytes —
 * operator-only, with no customer-door counterpart).
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminOrcaArchiveRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminOrcaArchiveRpcClient extends AtomRpc.Tag<AdminOrcaArchiveRpcClient>()(
  "AdminOrcaArchiveRpcClient",
  {
    group: AdminOrcaArchiveRpcs,
    protocol: makeRpcClientLayer(AdminOrcaArchiveRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
